// 配置全局变量
const domains = [
  // 接口用的ip地址
  "https://byl.sh.cn", // 192.168.3.100,  218.80.205.234, 122.144.211.63 // 部署要改
  "http://192.168.8.77", // usercenter--guoy
  "http://192.168.8.31", // payment--gaoy
];
const DEFAULT_DOMAIN = "www.byl.sh.cn";
const ports = ["12000", "8004", "1013"]; // 接口用的端口 // 部署要改第一个参数
const webport = "80"; // web项目端口 线上是默认80端口，测试环境目前是8079端口 // 部署要改
const DEPLOY = true; // false: 测试3.100/205.234环境， true: 线上正式环境 // 部署要改
const employee_sheets =
  "http://inesa-test.oss-cn-shanghai.aliyuncs.com/resource/1541668380192235915.xlsx"; // 员工导入模板阿里云地址
const upload_sheets =
  "http://inesa-test.oss-cn-shanghai.aliyuncs.com/resource/1548404326170464737.xlsx"; // 上传成绩模板阿里云地址
const org_sheets =
  "http://inesa-test.oss-cn-shanghai.aliyuncs.com/resource/1543479661822890466.xlsx"; // 机构导入模板阿里云地址
const question_sheets =
  "http://inesa-test.oss-cn-shanghai.aliyuncs.com/resource/1554701963444855271.xlsx"; // 考题导入模板阿里云地址
const scope_sheets =
  "http://inesa-test.oss-cn-shanghai.aliyuncs.com/resource/1554704451102681852.xlsx"; // 推送范围模板阿里云地址
/* 和RAP环境相关的变量 */
var DEV = false;
var MOCK = false;
/* --和RAP环境相关的变量-- */

var bylBaseCenterPath,
  UCApiPath,
  paymentApiPath,
  bylApiPath,
  resourceApiPath,
  courseApiPath,
  livePlayApiPath,
  examApiPath,
  teacherApiPath,
  enrollApiPath,
  planApiPath,
  certApiPath,
  messageApiPath,
  tagApiPath,
  fineReportPath;

if (DEV) {
  /* 白玉兰base */
  bylBaseCenterPath = MOCK
    ? domains[0] + ":" + ports[0] + "/mockjs/3"
    : "http://192.168.8.77:5000/bylBaseCenter";

  /* 白玉兰服务 */
  bylApiPath = MOCK
    ? "http://192.168.3.97:8061/mockjs/2"
    : "http://192.168.8.23:6001";

  /* 资源服务 */
  resourceApiPath = MOCK
    ? domains[0] + ":" + ports[0] + "/mockjs/6"
    : "http://192.168.8.77:8005";

  /* 课程服务 */
  courseApiPath = MOCK
    ? domains[0] + ":" + ports[0] + "/mockjs/5"
    : "http://192.168.8.77:8006";

  /* 直播服务 */
  livePlayApiPath = MOCK ? domains[0] + ":" + ports[0] + "/mockjs/9" : "";

  /* 考试服务 */
  examApiPath = MOCK ? domains[0] + ":" + ports[0] + "/mockjs/8" : "";

  /* 用户服务 */
  UCApiPath = MOCK
    ? domains[0] + ":" + ports[0] + "/mockjs/3"
    : "http://192.168.8.77:5000/bylBaseCenter";

  /* 讲师服务 */
  teacherApiPath = MOCK
    ? domains[0] + ":" + ports[0] + "/mockjs/15"
    : "http://192.168.8.77:5000/course-center";

  /* 报名服务 */
  enrollApiPath = MOCK
    ? domains[0] + ":" + ports[0] + "/mockjs/16"
    : "http://192.168.8.31:6001";

  /* 计划服务 */
  planApiPath = MOCK ? "http://192.168.3.97:8061/mockjs/14" : "";

  /* 证书服务 */
  certApiPath = MOCK ? domains[0] + ":" + ports[0] + "/mockjs/13" : "";

  /* 支付服务 */
  paymentApiPath = domains[2] + ":" + ports[2];
} else {
  bylBaseCenterPath = domains[0] + ":" + ports[0] + "/bylBaseCenter";

  bylApiPath = domains[0] + ":" + ports[0] + "/bylBusiness";

  resourceApiPath = domains[0] + ":" + ports[0] + "/resource-center";

  courseApiPath = domains[0] + ":" + ports[0] + "/course-center";

  livePlayApiPath = domains[0] + ":" + ports[0] + "/liveplaycenter";

  examApiPath = domains[0] + ":" + ports[0] + "/examCenter";

  teacherApiPath = domains[0] + ":" + ports[0] + "/course-center";

  enrollApiPath = domains[0] + ":" + ports[0] + "/bylBusiness";

  planApiPath = domains[0] + ":" + ports[0] + "/training-plan";

  certApiPath = domains[0] + ":" + ports[0] + "/cert-center";

  messageApiPath = domains[0] + ":" + ports[0] + "/messagecenter";

  paymentApiPath = domains[0] + ":" + ports[0] + "/paycenter";

  tagApiPath = domains[0] + ":" + ports[0] + "/tagcenter";

  fineReportPath = "http://report.bylonline.cn/WebReport/ReportServer";
}

const dictAPI = bylBaseCenterPath + "/dict/getDict";

// 进度条配置
const progressBarOptions = {
  color: "#bffaf3",
  failedColor: "#874b4b",
  thickness: "5px",
  position: "relative",
};

// 分页配置
const paginationOptions = {
  initial_page: 0,
  page_num: 8,
  container_class: "pagination",
  page_class: "page-item",
  page_link_class: "page-link-item",
  prev_class: "prev-item",
  prev_link_class: "prev-link-item",
  next_class: "next-item",
  next_link_class: "next-link-item",
  break_view_class: "break-view",
  break_view_link_class: "break-view-link",
  first_last_button: true,
  active_class: "active-class",
  disabled_class: "disabled-class",
  first_button_text: "首页",
  last_button_text: "尾页",
  prev_text: "上一页",
  next_text: "下一页",
};

export default {
  DEFAULT_DOMAIN,
  employee_sheets,
  upload_sheets,
  org_sheets,
  question_sheets,
  scope_sheets,
  webport,
  DEPLOY,
  domains,
  ports,
  dictAPI,
  bylBaseCenterPath,
  bylApiPath,
  UCApiPath,
  teacherApiPath,
  enrollApiPath,
  planApiPath,
  paymentApiPath,
  resourceApiPath,
  courseApiPath,
  livePlayApiPath,
  examApiPath,
  certApiPath,
  messageApiPath,
  tagApiPath,
  fineReportPath,

  progressBarOptions,
  paginationOptions,
};



// WEBPACK FOOTER //
// ./src/config/index.js